export enum DViewPage {
    DeviationsOverview = 'DeviationsOverview',
    DeviationsOpen = 'DeviationsOpen',
    DeviationsHocRatings = 'DeviationsHocRatings',
    Login = 'Login',
    Onboarding = 'Onboarding'
}